import {factory} from './localStorage'

export const LANGUAGE = factory('Language')
